import { render } from "./JoinStudioBlock.vue?vue&type=template&id=6aa162ed"
import script from "./JoinStudioBlock.vue?vue&type=script&lang=js"
export * from "./JoinStudioBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__